import { useAppSelector } from "../../hooks";

export default function useIsLoggedIn() {
  const currentUser = useAppSelector(state => state.currentPollworkerUser);
  return currentUser.EVUserId && currentUser.IsALoggedInUser;
}
